import React, {useEffect, useState} from "react";
import InvoiceSearchForm from "./InvoiceSearchForm";
import {
    getInvoiceDetailLines,
    listInvoicesByCustomerCode,
    listInvoicesByCustomerName, retrieveInvoiceSetting, retrieveInvoicesForToday,
    searchByInvoiceNumber, searchInvoiceByCustomerOrderNumber
} from "../../redux/invoice-list/InvoiceListServerActions";
import {connect} from "react-redux";
import {
    Container,
    Grid,
    makeStyles,
    Typography
} from "@material-ui/core";
import InvoiceCard from "./InvoiceCard"
import Controls from "../../components/controls/Controls"
import {
    closeNotificationClose,
    filterInvoices,
    formValueChanged
} from "../../redux/invoice-list/InvoiceListViewActions";
import {Pagination} from "@material-ui/lab";
import Notification from "../../components/Notification";
import QuickDetailLineView from "./QuickDetailLineView";
import {NOTIFICATION_TIME} from "../../helpers/NotificationHelper";

const useStyles = makeStyles(theme => ({
    noInvoiceFound: {
        display: "flex",
        justifyContent: 'center',
        marginTop: '14rem'
    },
    searchBarContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    searchContainer: {
        display: 'flex',
        alignItems: 'flex-end'
    },
    paginationContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        margin: theme.spacing(2)
    },
    itemPerPageStyle: {
        display: 'flex',
        justifyContent: 'flex-end'
    },

    pageActionsContainer: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2),
        display: 'flex',
        justifyContent: 'space-between'
    }
}))

let defaultInvoiceList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

function InvoiceList(props) {

    const styles = useStyles();
    const {
        getInvoiceSetting,
        getInvoicesForToday,
        searchByInvoiceNumber,
        searchInvoiceByCustomerCode,
        searchInvoiceByCustomerName,
        searchInvoiceByCustomerOrderNumber,
        invoiceList,
        filterInvoices,
        closeNotification,
        getInvoiceDetailLines,
        handleFormValueChange,
    } = props;
    const [invoiceSearchKey, setInvoiceSearchKey] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [invoicePerPage, setInvoicesPerPage] = React.useState(24);
    const [showQuickViewDetailLineDialog, setShowQuickViewDetailLineDialog] = useState(false);
    const [listTitle, setListTitle] = useState('Invoices for today');
    const [invoicesOnly, setInvoicesOnly] = useState(true);
    const [searchTypeText, setSearchTypeText] = useState("Invoice");

    useEffect(() => {
        getInvoiceSetting();
        getInvoicesForToday();
    }, [getInvoiceSetting, getInvoicesForToday])


    const handleInvoicesOnlyChange = (event) => {
        setInvoicesOnly(event.target.checked);
        setSearchTypeText(event.target.checked ? 'Invoice' : 'Order')
    }



    const getCurrentTransactions = (type) => {
        getInvoicesForToday(type)
        setListTitle(invoicesOnly ? 'Invoices for today' : 'Orders for today');
    }
    const handleItemPerPageChange = (event) => {
        setInvoicesPerPage(event.target.value);
    };
    const handleInvoiceSearchChange = (e) => {
        let searchKey = e.target.value
        setInvoiceSearchKey(searchKey);
        filterInvoices(searchKey)
    }
    const handleSearchByInvoiceNumber = (type, invoiceNumber) => {
        searchByInvoiceNumber(type, invoiceNumber);
        setListTitle(`${invoicesOnly ? 'Invoices' : 'Orders'} for ${searchTypeText} number ${invoiceNumber}`)
        resetSearchKey();
    }

    const handleSearchByCustomerCode = (type, startDate, endDate, customerCode) => {
        searchInvoiceByCustomerCode(type, startDate, endDate, customerCode);
        setListTitle(`${invoicesOnly ? 'Invoices' : 'Orders'} for customer code ${customerCode} starting from ${startDate} to ${endDate}`)
        resetSearchKey();
    }

    const handleSearchByCustomerName = (type, startDate, endDate, customerName) => {
        searchInvoiceByCustomerName(type, startDate, endDate, customerName);
        setListTitle(`${invoicesOnly ? 'Invoices' : 'Orders'} for customer  ${customerName} starting from ${startDate} to ${endDate}`)
        resetSearchKey();
    }

    const handleSearchByCustomerOrderNumber = (type, customerOrderNumber) => {
        searchInvoiceByCustomerOrderNumber(type, customerOrderNumber);
        setListTitle(`${invoicesOnly ? 'Invoices' : 'Orders'} for customer order number  ${customerOrderNumber}.`)
        resetSearchKey();
    }


    function resetSearchKey() {
        setInvoiceSearchKey("");
        setCurrentPage(1)
    }

    const handlePaginationChange = (event, value) => {
        setCurrentPage(value);
    };


    function getPagination() {
        if (invoiceList && invoiceList.filteredInvoices && invoiceList.filteredInvoices.length > invoicePerPage) {
            return <Pagination count={Math.ceil(invoiceList.filteredInvoices.length / invoicePerPage)}
                               page={currentPage} color="primary"
                               size='large'
                               onChange={handlePaginationChange}/>
        }
        return null;
    }

    function handleNotificationClose() {
        closeNotification();
    }

    const handleViewDetailLinesClick = (source, invoiceNumber) => {
        setShowQuickViewDetailLineDialog(true);
        getInvoiceDetailLines(source, invoiceNumber)
    }
    const handleQuickViewDetailLineClose = () => {
        setShowQuickViewDetailLineDialog(false);
    }
    const classes = useStyles();
    return (

        <div>
            {invoiceList.isLoading ?
                <Controls.ProgressBar/> : null}
            <Container maxWidth='xl'>
                <InvoiceSearchForm handleSearchByInvoiceNumber={handleSearchByInvoiceNumber}
                                   handleSearchByCustomerCode={handleSearchByCustomerCode}
                                   handleSearchByCustomerName={handleSearchByCustomerName}
                                   handleSearchByCustomerOrderNumber={handleSearchByCustomerOrderNumber}
                                   handleItemPerPageChange={handleItemPerPageChange}
                                   invoicePerPage={invoicePerPage}
                                   getCurrentTransactions={getCurrentTransactions}
                                   invoicesOnly={invoicesOnly}
                                   searchTypeText={searchTypeText}
                                   handleInvoicesOnlyChange={handleInvoicesOnlyChange}
                                   supportSalesOrder={invoiceList.setting.supportSalesOrder}
                                   startDate={invoiceList.formValues.startDate}
                                   handleFormValueChange={handleFormValueChange}

                />
                <div>
                    <div className={classes.pageActionsContainer}>
                        <Grid container spacing={2}>
                            <Grid item sm={12} md={9}>
                                <Typography variant='h6' color='textSecondary'>{listTitle}</Typography>
                            </Grid>

                            <Grid item sm={12} md={3} className={classes.itemPerPageStyle}>

                                <div className={classes.searchContainer}>
                                    <Controls.Input
                                        name="searchInvoice"
                                        label={`Search ${invoicesOnly ? 'invoices' : 'orders'}`}
                                        value={invoiceSearchKey}
                                        onChange={handleInvoiceSearchChange}
                                        fullWidth={false}
                                    />
                                    <Typography variant='body2' color='textSecondary'
                                                display='inline'>{invoiceList.filteredInvoices.length > 1 ? invoiceList.filteredInvoices.length + ` ${invoicesOnly ? 'invoices' : 'orders'} ` : invoiceList.filteredInvoices.length + ` ${invoicesOnly ? 'invoice' : 'order'} `}
                                        found</Typography>
                                </div>

                            </Grid>
                        </Grid>
                    </div>

                    {
                        invoiceList.isLoading ?
                            <div>
                                <Grid container spacing={2}>
                                    {defaultInvoiceList.map(index => {
                                        return <Grid key={index} item xs={12} md={3}>
                                            <InvoiceCard
                                                loading={invoiceList.isLoading}
                                            /></Grid>
                                    })}
                                </Grid>
                            </div> : (
                                invoiceList && invoiceList.filteredInvoices &&
                                invoiceList.filteredInvoices.length > 0 ?
                                    <div>
                                        <Grid container spacing={2}>
                                            {invoiceList.filteredInvoices.slice((currentPage - 1) * invoicePerPage, (currentPage - 1) * invoicePerPage + invoicePerPage).map(invoice => {
                                                return <Grid key={invoice.invoiceNumber} item xs={12} sm={6} md={3}>
                                                    <InvoiceCard
                                                        handleViewDetailLinesClick={handleViewDetailLinesClick}
                                                        invoice={invoice}
                                                        loading={invoiceList.isLoading}
                                                        displayPriceField={invoiceList.setting.displayPriceField}/>
                                                </Grid>
                                            })}
                                        </Grid>
                                        <div className={classes.paginationContainer}>
                                            {getPagination()}
                                        </div>
                                    </div> :
                                    <Typography className={styles.noInvoiceFound} variant='body1' color='textSecondary'>No
                                        records found</Typography>
                            )

                    }

                </div>
                <div>
                    <Notification
                        open={invoiceList.notification.show}
                        type={invoiceList.notification.type}
                        message={invoiceList.notification.message}
                        handleClose={handleNotificationClose}
                        position={{vertical: 'top', horizontal: 'center'}}
                        hideDuration={invoiceList.notification.type === 'error' ? null : NOTIFICATION_TIME}
                    />
                    <QuickDetailLineView
                        open={showQuickViewDetailLineDialog}
                        handleClose={handleQuickViewDetailLineClose}
                        invoiceDetail={invoiceList.invoiceDetail}
                        displayItemCodeField={invoiceList.setting.displayItemCodeField}
                        displayPriceField={invoiceList.setting.displayPriceField}
                    />
                </div>
            </Container>
        </div>);
}

const mapStateToProps = state => {
    return {
        invoiceList: state.invoiceList
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getInvoicesForToday: (type = 1) => retrieveInvoicesForToday(type),
        searchByInvoiceNumber: (type, invoiceNumber) => searchByInvoiceNumber(type, invoiceNumber),
        searchInvoiceByCustomerCode: (type, startDate, endDate, customerCode) => listInvoicesByCustomerCode(type, startDate, endDate, customerCode),
        searchInvoiceByCustomerName: (type, startDate, endDate, customerName) => listInvoicesByCustomerName(type, startDate, endDate, customerName),
        searchInvoiceByCustomerOrderNumber: (type, customerOrderNumber) => searchInvoiceByCustomerOrderNumber(type, customerOrderNumber),
        filterInvoices: (searchKey) => filterInvoices(searchKey),
        closeNotification: () => closeNotificationClose(),
        getInvoiceDetailLines: (source, invoiceNumber) => getInvoiceDetailLines(source, invoiceNumber),
        getInvoiceSetting: () => retrieveInvoiceSetting(),
        handleFormValueChange: (nameValue) => formValueChanged(nameValue)
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps()
)(InvoiceList);
